export default "__VITE_PUBLIC_ASSET__de0ada7d__"